import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardOptions: null,
  currentDashboard: null,
  toggleDataAnalyticsButton: false,
  currentDashboardRange: null,
  selectedCard: null,
};

export const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    setDashboardOptions: (state, action) => {
      state.dashboardOptions = action.payload;
    },
    setCurrentDashboard: (state, action) => {
      state.currentDashboard = action.payload;
    },
    setToggleDataAnalyticsButton: (state, action) => {
      state.toggleDataAnalyticsButton = action.payload;
    },
    setCurrentDashboardRange: (state, action) => {
      state.currentDashboardRange = action.payload;
    },
    setSelectedCard: (state, action) => {
      state.selectedCard = action.payload;
    },
    resetDashboard: () => {
      return initialState;
    },
  },
});

export const {
  setDashboardOptions,
  setCurrentDashboard,
  setToggleDataAnalyticsButton,
  setCurrentDashboardRange,
  setSelectedCard,
  resetDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
